import { render, staticRenderFns } from "./icon-picker-field.vue?vue&type=template&id=de3fcdee&"
import script from "./icon-picker-field.vue?vue&type=script&lang=js&"
export * from "./icon-picker-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_webpack@5.75.0__lodash@4.17.21_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports